import { SwapIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const RepeatComment = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <SwapIcon size={Sizes[size]} {...rest} />;
};

RepeatComment.displayName = 'RepeatComment';
